import { useMemo } from "react";
import {
  TextField,
  DatagridConfigurable,
  NumberField,
  useTheme,
  useTranslate,
} from "react-admin";
import productRankingFilterList from "../../components/productRankings/filter/productRankingFilterList";
import DownloadAction from "../../components/tableListActions/DownloadActionNew";
import getFirstAndLastDateOfCurrentMonth from "../../utils/firstLastDate";
import getLastMonthsRange from "../../utils/lastMonthsRange";
import ManualReportList from "../../components/reports/ManualReportList";
import useCompanyScopedListFilters from "../../hooks/useCompanyScopedListFilters";

const [_, lastDate] = getFirstAndLastDateOfCurrentMonth();
const [firstDate] = getLastMonthsRange(lastDate);

const ProductRankingList = (props) => {
  const { permissions, canSeeCompanyColumn, filterDefaultValues } =
    useCompanyScopedListFilters({
      start_date: firstDate,
      end_date: lastDate,
    });
  const [theme] = useTheme("light");
  const t = useTranslate();

  const list = useMemo(() => {
    return (
      <ManualReportList
        title="mine.list_title.product_ranking"
        empty={false}
        actions={<DownloadAction field="total_profit" order="DESC" />}
        filters={productRankingFilterList(permissions)}
        filterDefaultValues={filterDefaultValues}
        requiredFilters={["start_date", "end_date"]}
        queryOptions={{ meta: { sort: ["total_profit DESC"] } }} // total_profit adalah kolom hasil SUM(), bukan kolom di database
        sx={{
          flexDirection: "column",
        }}
      >
        <DatagridConfigurable
          bulkActionButtons={false}
          sx={{
            "& .increment-column": { width: "50px" },
            "& .RaDatagrid-expandedPanel > td": {
              p: 0,
              bgcolor: theme !== "dark" ? "#E7EBF0" : "grey.800",
            },
          }}
        >
          <NumberField
            source="increment_value"
            label="No."
            textAlign="center"
            headerClassName="increment-column"
          />
          {canSeeCompanyColumn ? (
            <TextField label="Nama Depo" source="company_name" />
          ) : null}
          <TextField source="code" label="mine.label.product_code" />
          <NumberField
            source="ranking_total_profit"
            label="Rank Profit"
            textAlign="center"
          />
          <NumberField
            source="ranking_quantity_sold"
            label="Rank Quantity"
            textAlign="center"
          />
          <NumberField source="total_average_profit" label="Profit" />
          <NumberField source="total_quantity_sold" label="Total Quantity" />
          <NumberField
            source="average_sales_per_month"
            label="Avg Sales / Bln"
          />
          <NumberField
            source="months_sold"
            label="mine.label.effective_month"
            textAlign="center"
          />
        </DatagridConfigurable>
      </ManualReportList>
    );
  }, [theme, permissions, canSeeCompanyColumn, filterDefaultValues]);
  return list;
};

export default ProductRankingList;
